import React, { useContext } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import SortSelect from "components/organisms/search/SortSelect/SortSelect";
import SearchPageContext from "pages/SearchPageV1/SearchPageV1Context";

import { H2 } from "components/core/Typography";

import "./SearchToolbar.scss";

const SearchToolbar = ({ count, showSortSelect = true, currentRange }) => {
	const { handleSortChange, selectedSort, pageType, location } =
		useContext(SearchPageContext);

	const { city, state } = location || {};
	const isNMP = pageType === "nearMeSearchPage";
	const rangeStr = currentRange || `1-${count < 20 ? count : "20"}`;
	const resultsText = isNMP
		? `${rangeStr} of ${count} Storage Units Near Me`
		: `Displaying ${rangeStr} of ${count} Storage Facilities in ${city}, ${state}`;

	return (
		<div
			className={classnames("search-toolbar", {
				divider: !showSortSelect
			})}
		>
			{/* X facilities found near Y, Z */}
			<H2 className="results-count">{resultsText}</H2>
			{showSortSelect && (
				<SortSelect
					onChange={handleSortChange}
					selected={selectedSort}
					useThinSelect
					labelProps={{
						className: "sort-select-label"
					}}
				/>
			)}
		</div>
	);
};
SearchToolbar.propTypes = {
	count: PropTypes.number.isRequired,
	showSortSelect: PropTypes.bool,
	currentRange: PropTypes.string
};
export default SearchToolbar;
